import React, {useState} from 'react'
import {InputAdornment,FormHelperText, Divider, Snackbar, Box, Button, InputLabel, Typography, TextField, Select, MenuItem, FormControl } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useForm, Control  } from "react-hook-form";
import * as firebase from 'firebase';
import Alert from '@material-ui/lab/Alert';
import dayjs from 'dayjs'
import _ from 'lodash'
import useMediaQuery from '@material-ui/core/useMediaQuery';
import {tankstellen} from '../CustomerSide/TankstelleListe'
import Autocomplete from '@material-ui/lab/Autocomplete';



const useStyles = makeStyles((theme)=>({
    button:{
      color:'white'
    }, 
    input:{
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      color:'white',
      width: '100%'
    }, 
    logo:{
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      padding: theme.spacing(2)
    }
  }));


export default function SellerForm() {
    const classes = useStyles()
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up('sm'));
    const functions = firebase.functions()
    const [isSuccessful, setIsSuccessful] = React.useState()
    const [error, setError] = React.useState()
    const { register, handleSubmit, control, errors } = useForm();
    const [prices, setPrices] = React.useState()
    const [station, setStation] = React.useState('');
    const [fuel, setFuel] = React.useState('')
    let db = firebase.firestore()
    const [discount, setDiscount] = React.useState()
    const [dateValid, setDateValid] = React.useState()
    const sendFeedback = functions.httpsCallable('sendFeedbackEmail')
    const [couponData, setCouponData] = useState()
    const [stationName, setStationName] = useState()

    const stationNames={
        'b3060ae1-10ad-4229-b2db-096372950f51':'Total - Heidestr. 18, 10557 Berlin',
        '8a7a3916-0deb-46ba-bef9-4531c0cb1c7c':'Total - Heerstr. 35-37, 14055 Berlin',
        '73f34ee9-64ab-4009-a092-575ce13ce326':'Total - Schöneberger Str. 17, 12103 Berlin',
        'be5c6214-ea9b-4fde-8355-42b80dbcb9df':'Total - Elly-Beinhorn-Ring 2A, 12529 Schönefeld',
      }

    const handleFuelChange = (event) =>{
        setFuel(event.target.value)
    }
    console.log(prices, station, )
    const formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,      
        maximumFractionDigits: 2,
     });

    React.useEffect(() => {
            const timer = setTimeout(() => {
                if(station!=''&&isSuccessful!=true){
                fetch(`https://creativecommons.tankerkoenig.de/json/prices.php?ids=${station}&apikey=b2286900-6abe-8fc5-0f11-16ff21eb0a9d`)
                    .then(res => res.json())
                    .then((data) => {
                    setPrices(data.prices[station])
                    console.log('Ran')
                    })
                    .catch(console.log)}
              }, 900000);
              return () => clearTimeout(timer); 
        
    }, [station,prices]) 

    

    const handleStationChange = (event, newValue) => {
        setStation(newValue.id)
        setStationName(`${newValue.brand} - ${newValue.street}, ${newValue.post_code} ${newValue.place}`)
        fetch(`https://creativecommons.tankerkoenig.de/json/prices.php?ids=${newValue.id}&apikey=b2286900-6abe-8fc5-0f11-16ff21eb0a9d`)
        .then(res => res.json())
        .then((data) => {
          setPrices(data.prices[newValue.id])
        })
        .catch(console.log)
      }
    
    const calculateDiscount= (volume, fuel2, price) =>{
        let currentPrice = volume*prices[fuel2]
        let discountedPrice = volume*price
        let disc = currentPrice - discountedPrice
        setDiscount(disc)
        return disc
    }

    const compareDates= (date) =>{
        const validDate = dayjs(date.toDate()).add(1, 'd')
        let isGood = !validDate.isBefore(dayjs())
        return isGood}
    const checkFuel = (customerFuel)=>{
        if(customerFuel==fuel){
            return true
        }else{
            return false
        }
    }

    const checkVolume = (volume)=>{
        if(volume>70){
            return true
        }else{
            return false
        }
    }

    const onSubmit = async (data) =>{
        db.collection("coupons").where("code", "==", parseInt(data.code))
        .where("collected", "==", false)
        .limit(1)
        .get()
        .then(async function(querySnapshot) {
            if (!querySnapshot.empty) {
                const couponDocument = querySnapshot.docs[0]
                const data2 = couponDocument.data()
                const isValid = data2.stationCode==station
                const date= data2.claimedTime

                setCouponData(data2)
                if(compareDates(date)==false){
                    setError('Der Rabatt-Code ist abgelaufen.')
                    return
                }
                if(checkVolume(data.volume)==true){
                    console.log(data.volume)
                    setError('Das Volumen überschreitet die maximale Menge von 70 Litern.')
                    return
                }
                if(checkFuel(data2.fuel)==false){
                    setError(`Dieser Code gilt nur für ${data2.fuel!=='diesel'?'Super '+_.capitalize(data2.fuel):_.capitalize(data2.fuel)}`)
                    return
                }
                if(isValid&&compareDates(date)&&checkFuel(data2.fuel)){
                    setError()
                    const calcDiscount = calculateDiscount(data.volume, data2.fuel, data2.price)
                    if(calcDiscount>0){
                        
                        await db.collection("coupons").doc(couponDocument.id).set({
                            collected: true,
                            collectedTime: new Date(),
                            discount: calcDiscount,
                            collectedLiters: data.volume,
                            collectedPrice: prices[data2.fuel]
                        }, { merge: true }).then(()=>{
                            sendFeedback({email: data2.email})
                            setIsSuccessful(true)
                        }).catch(()=>setError("Fehler beim Abrufen der Dokumente"))
                    }else{
                        setIsSuccessful(true)
                    }
                    
                } else {
                setError(!isValid?`Dieser Gutschein gilt nur für die Tankstelle: ${data2.stationAdress}`:'Der Code ist abgelaufen' ) 
                return       
                    }
                    
            } else {
                setError('Es gibt keinen solchen Code in der Datenbank')
            }
        }).catch(function(error) {
               if(!error) {setError("Fehler beim Abrufen der Dokumente:", error.message)};
            });
    }

    return (
        <Box style={{height:!matches&&!station?'100vh':null}}>
    {/* TO DO: set up an autocomplete field  */}
    <form onSubmit={handleSubmit(onSubmit)}>
    <Box className={classes.logo}>
    <img  src='https://firebasestorage.googleapis.com/v0/b/meintankpreis.appspot.com/o/Group%20149.png?alt=media&token=e59e2eda-6d68-4e90-b0f4-269d917289d0'/>
    </Box>
         {!station?  
        <FormControl className={classes.input} variant='outlined'> 
        <Autocomplete
                  id="tankstellen"
                  required
                  disableClearable
                  options={tankstellen}
                  getOptionLabel={(tank)=>`${tank.brand} - ${tank.street}, ${tank.post_code} ${tank.place}`}
                  onChange={handleStationChange}
                  renderInput={(params) => <TextField {...params} label="Tankstelle auswahlen" variant="outlined" color='secondary' />}
                />
                {/* <InputLabel color='secondary' id="fuelid">Tankstelle auswahlen</InputLabel>
             <Select 
                name='station'
                label='Tankstelle auswahlen'
                labelId="fuelid"
                required
                value={station}
                onChange={handleStationChange}
                variant='outlined'
                color='secondary'
                >
                <MenuItem value='b3060ae1-10ad-4229-b2db-096372950f51'>Heidestr. 18, 10557 Berlin</MenuItem>
                <MenuItem value='8a7a3916-0deb-46ba-bef9-4531c0cb1c7c'>Heerstr. 35-37, 14055 Berlin</MenuItem>
                <MenuItem value='73f34ee9-64ab-4009-a092-575ce13ce326'>Schöneberger Str. 17, 12103 Berlin</MenuItem>
                <MenuItem value='be5c6214-ea9b-4fde-8355-42b80dbcb9df'>Elly-Beinhorn-Ring 2A, 12529 Schönefeld</MenuItem>
                </Select> */}
                </FormControl>:
                <React.Fragment>
            {isSuccessful==true?
            <React.Fragment>
            {discount<=0?
            <Typography color='textPrimary' align='center'>
            Der aktuelle Preis ist niedriger oder genauso hoch wie der reservierte Preis. Es gilt kein Rabatt.<br/><br/>Der Code ist noch gültig und der Kunde kann ihn verwenden, wenn der Preis höher ist bis {couponData.expiryTime}.</Typography>:
            <React.Fragment> 
            <Typography color='textPrimary' align='center'>
            Erfolg! Der Rabatt beträgt:</Typography>
            <Typography style={{padding:'20px'}} color='textPrimary' variant='h3' align='center'>
            {discount<7?Math.ceil(discount):7}€</Typography>
            <Divider light style={{paddingBottom: '1px', marginBottom:'20px', marginTop:'10px'}}/>
            <Typography style={{padding:'20px'}} color='textPrimary' variant='body1' align='center'>
            Nutze die Festtaste „meinTankpreis“ in der Kasse und wähle den hier angezeigten Rabatt über den Artikel aus.
            </Typography>
            </React.Fragment>}
            </React.Fragment>:
            isSuccessful==false?<Typography color='error' align='center' >Error</Typography>:
            <React.Fragment>
            <Typography style={{paddingTop: '20px'}} variant='subtitle1' color='textSecondary'>{stationName}</Typography>
            <Divider light style={{paddingBottom: '1px', marginBottom:'20px', marginTop:'10px'}} />
            <TextField 
            className={classes.input}
            name='code'
            inputRef={register({ required: true })}
            variant='outlined' 
            label='Rabatt-Code'
            type='number'
            inputProps={{maxLength :6}}
            required
            color='secondary'
            helperText='Geben Sie einen 6-stelligen Rabatt-Code ein.'
            />
            <FormControl className={classes.input} variant='outlined'> 
                <InputLabel color='secondary' id="fuel">Kraftstoff</InputLabel>
             <Select 
                name='fuel'
                label='Kraftstoff'
                labelId="fuel"
                required
                value={fuel}
                onChange={handleFuelChange}
                variant='outlined'
                color='secondary'
                >
                <MenuItem value='e10'>Super E10</MenuItem>
                <MenuItem value='e5'>Super E5</MenuItem>
                <MenuItem value='diesel'>Diesel</MenuItem>
                </Select>
                <FormHelperText required={true}>Geben Sie die Art des Kraftstoffs ein, den der Kunde getankt hat.</FormHelperText>
                </FormControl>
            
            <TextField
            inputRef={register({ required: true })}
            name='volume'
            className={classes.input}
            variant='outlined' 
            label='Volumen'
            type='number'
            required
            helperText='Geben Sie das aufgerundete Tankvolumen ein.'
            color='secondary'
            InputProps={{
                    endAdornment: <InputAdornment position="end">liter</InputAdornment>,
                }}
            />
            {error?
            <Snackbar open={error?true:false}  onClose={()=>setError()}>
            <Alert onClose={()=>setError()} severity="error" variant='filled'>
                {error}
            </Alert>
            </Snackbar>:null}
            </React.Fragment>
            }
            <Button fullWidth type='submit' className={classes.input} style={{color: 'white'}} color='secondary' variant='contained' onClick={isSuccessful?()=>setIsSuccessful():null} >{isSuccessful?'Wiederholen':'Senden'}</Button>
            </React.Fragment>}

    </form>
        </Box>
    )
}
